import React, { ReactElement, useEffect } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { IntlProvider } from 'react-intl'

// import * as typings from 'typings'

import * as locationSelectors from 'services/Location/selectors'
import * as localisationSelectors from 'services/Localisation/selectors'
import { Dispatch } from 'redux'
import * as localisationActions from 'services/Localisation/actions'
import { extractTranslations } from './utils'

type Props = {
  children?: ReactElement<any>
} & ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>

const mapStateToProps = createStructuredSelector({
  location: locationSelectors.locale,
  showLID: localisationSelectors.showLID,
  translations: localisationSelectors.getTranslations,
})

type PropsFromDispatch = {
  setLocalisations: (wordings: any) => void
}

const mapDispatchToProps = (
  dispatch: Dispatch<ActionType>,
): PropsFromDispatch => ({
  setLocalisations: wordings =>
    dispatch(localisationActions.setLocalisations(wordings)),
})

const IntlContainer: React.FC<Props> = ({
  location: { language, country },
  children,
  showLID,
  translations,
  setLocalisations,
}) => {
  useEffect(() => {
    const setWordings = async () => {
      const wordings = await extractTranslations(country, language)
      setLocalisations(wordings)
    }

    if (country && language) {
      setWordings()
    }
  }, [])

  return (
    <IntlProvider
      key={`${language}-${showLID}`}
      locale={language}
      messages={translations}
    >
      {Object.keys(translations).length ? children : <></>}
    </IntlProvider>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(IntlContainer)
